import { mutatorAction } from 'satcheljs';
import { getProactiveDraftsStore } from '../store/store';

const proactiveDraftAddedOnEditorMutator: (itemId: string | undefined, editorId: string) => void =
    mutatorAction(
        'proactiveDraftAddedOnEditorMutator',
        function proactiveDraftAddedOnEditor(itemId: string | undefined, editorId: string): void {
            if (!itemId) {
                return;
            }

            const proactiveDraftsStore = getProactiveDraftsStore();
            const proactiveDraftsState = proactiveDraftsStore.proactiveDraftsListMap.get(itemId);
            if (proactiveDraftsState) {
                proactiveDraftsState.proactiveDraftsAddedOnEditorList.push(editorId);
            }
        }
    );
export default proactiveDraftAddedOnEditorMutator;
